import { postJson1, post1, get1, deleteApi1 } from "../axios";
import { get } from "../cpdAxios";

const RESOURCE_BASE_PATH = "/yunqi-ai-api";

// 分页查询推荐问题列表
export const getRecommended = (p) =>
  get1(`${RESOURCE_BASE_PATH}/ai-recommend-question/page`, p);

// 点赞、踩接口
export const likeAndStep = (p) =>
  post1(`${RESOURCE_BASE_PATH}/chat/setLikeOrDislikeStatus`, p);

// 查询短信生成历史记录接口（取前20条）
export const AIList = p => get1(`${RESOURCE_BASE_PATH}/sms-ai-content-record/list`, p);

// 生成AI短信文案接口
export const monkey = p => postJson1(`${RESOURCE_BASE_PATH}/sms-ai-content-record/buildContent`, p);

// 根据请求ID查询应答信息接口
export const AI = p => get1(`${RESOURCE_BASE_PATH}/sms-ai-content-record/getResponse/${p}`);

// 重新生成文案接口
export const AIAgain = p => get1(`${RESOURCE_BASE_PATH}/sms-ai-content-record/reBuild/${p}`);

// 意图识别接口
export const recognizeIntent = p => postJson1(`${RESOURCE_BASE_PATH}/chat/recognize-intent`, p);

// 创建对话接口
export const createConversation = p => postJson1(`${RESOURCE_BASE_PATH}/chat/conversation/create`, p);

// 分页查询对话列表接口
export const getConversationPage = p => postJson1(`${RESOURCE_BASE_PATH}/chat/conversation/page`, p);

// 删除对话接口
export const deleteConversation = p => deleteApi1(`${RESOURCE_BASE_PATH}/chat/${p}`);

// AGENT_BI场景对话
export const reportData = p => postJson1(`${RESOURCE_BASE_PATH}/ai/dataReport/report`, p);

// 根据请求的数据报表reqId获取数据明细
export const queryData = p => postJson1(`${RESOURCE_BASE_PATH}/ai/dataReport/queryData`, p);

// 分页查询对话消息接口
export const getMessagesPage = p => postJson1(`${RESOURCE_BASE_PATH}/chat/messages/page`, p);

// 根据对话ID查询报表详情JSON
export const getReportById = msgId => get1(`${RESOURCE_BASE_PATH}/ai-analysis/report/${msgId}`);

// 根据对话ID查询选择项JSON
export const getSelectData = (msgId) => get1(`${RESOURCE_BASE_PATH}/ai-analysis/select-items/${msgId}`);

// 根据对话ID查询选择项数据JSON
export const getSelectDataJson = (conversationId) => get1(`${RESOURCE_BASE_PATH}/ai-analysis/select-items-data-json/${conversationId}`);

// 获取BI分类
export const getSellerBICategory = p => get(`/api/mainInfoController/getSellerTBCategory`, p);

// 根据对话ID查询报表详情JSON
export const exportAiAnalysis = p => postJson1(`${RESOURCE_BASE_PATH}/ai-analysis/export`, p);